export const getAssetUrl = (assetPath) => process.env.BASE_PATH + assetPath;
